import type { ReduxApplicationState } from 'src/redux/combinedReducer';

export const selectPageType = (state: ReduxApplicationState) => state.navigation.pageType;

export const selectPathname = (state: ReduxApplicationState) => state.navigation.pathname;

export const selectHash = (state: ReduxApplicationState) => state.navigation.hash;
